<template>
    <!-- 监考详情 列表页 -->
    <div class="board">
        <div v-hasPermi="['invigilate:detail:list']" class="invigilate-detail-board" ref="boardRef">
            <div class="title">
				<span>
					<el-button type="text" icon="el-icon-arrow-left" @click="$router.push({name:'invigilate'})">{{ detailTextConfig.back }}</el-button>
					<el-divider direction="vertical"></el-divider>
					<span class="name">{{ detailTextConfig.title }}</span>
				</span>
            </div>
            <el-tabs v-model="form.authenticationType" type="card">
                <el-tab-pane label="考生" name="examinee">
                    <el-form :inline="true" :model="form" ref="form">
                        <el-form-item>
                            <el-input v-model.trim="form.examineeName" clearable :placeholder="searchTextConfig.examineeName"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-input v-model.trim="form.admissionNo" clearable :placeholder="searchTextConfig.admissionNo"></el-input>
                        </el-form-item>

                        <el-form-item>
                            <el-select v-model="form.faceCheckStatus" clearable :placeholder="searchTextConfig.faceCheckStatus">
                                <el-option v-for="item in faceCheckStatusOptions" :key="item.dict_value" :label="item.dict_label"
                                           :value="item.dict_value"></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item>
                            <el-select v-model="form.ifRemark" clearable :placeholder="searchTextConfig.ifRemark">
                                <el-option v-for="item in ifRemarkOptions" :key="item.dict_value" :label="item.dict_label"
                                           :value="item.dict_value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="search(1)">{{ searchTextConfig.select }}</el-button>
                            <el-button @click="reset">{{ searchTextConfig.reset }}</el-button>
                        </el-form-item>
                        <el-form-item>
                          <span>
                            <el-button v-hasPermi="['invigilate:detail:download']" type="primary" @click="download" :loading="examinerLoading" style="margin-left: 10px">
                              {{ detailTextConfig.button.download }}
                            </el-button>
                          </span>
                        </el-form-item>
                        <el-form-item>
                          <span>
                            <el-button type="primary" @click="downloadImg" :loading="examinerImgLoading" style="margin-left: 10px">
                              {{ detailTextConfig.button.downloadImg }}
                            </el-button>
                          </span>
                        </el-form-item>
                    </el-form>
                    <el-table :data="tableData" v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading"
                              ref="multipleTable" stripe size="medium" style="width:100%">
                        <el-table-column prop="examinee.examineeName" :label="tableTextConfig.examineeName" min-width="100px" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <div>
                                    {{ scope.row.examinee.examineeName }}
                                    <span class="lockedClass" v-if="scope.row.ifRemark">记录</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="examinee.admissionNo" :label="tableTextConfig.admissionNo" min-width="120px"
                                         show-overflow-tooltip></el-table-column>
                        <el-table-column prop="examTime" :label="tableTextConfig.examTime" width="300px" align="center" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span v-if="scope.row.startTime">{{ scope.row.startTime }}</span>
                                <span v-if="scope.row.startTime || scope.row.endTime"> ~ </span>
                                <span v-if="scope.row.endTime">{{ scope.row.endTime }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="loginIp" :label="tableTextConfig.loginIp" width="150px" align="center" show-overflow-tooltip>
                            <template slot-scope="scope" v-if="scope.row.loginIp">
                                <p v-for="(item, index) in scope.row.loginIp.split(',')" :key="index" class="multiRow">
                                    {{ item }}
                                </p>
                            </template>
                        </el-table-column>
                        <el-table-column prop="submitType" :label="tableTextConfig.submitType" :formatter="submitTypeFormatter" width="120px"
                                         align="center" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column prop="faceCheckStatus" :label="tableTextConfig.faceCheckStatus" width="200px" align="center"
                                         show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column fixed="right" :label="tableTextConfig.operate" width="240px" align="center">
                            <template slot-scope="scope">
                                <el-button v-hasPermi="['invigilate:detail:list']" plain type="primary" size="mini" @click="detail(scope.row)">
                                    {{ tableButtonTextConfig.detail.name }}
                                </el-button>
                                <el-button v-hasPermi="['invigilate:detail:remark']" plain type="primary" size="mini"
                                           @click="remarkDialogVisible = true, row = scope.row">
                                    {{ tableButtonTextConfig.remark.name }}
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <pagination v-show="tableData.length" :currentPage.sync="form.pageNumber" :pageSize.sync="form.pageSize"
                                :total.sync="total"></pagination>
                    <remark-dialog :row.sync="row" :show.sync="remarkDialogVisible" @close="close"></remark-dialog>
                    <detail-dialog :row.sync="row" :show.sync="detailDialogVisible" @close="close"></detail-dialog>
                </el-tab-pane>
                <el-tab-pane label="工作人员" name="reviewer">
                    <reviewer></reviewer>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
import remarkDialog from './components/remark.vue'
import detailDialog from './components/detail.vue'
import pagination from '@/components/pagination/pagination.vue'
import reviewer from './reviewer.vue'
import {getDict} from "@/api/dict";
import {getConfig} from "@/api/aiReview";
import {getDetailList} from "@/api/invigilate";
import {downloadBolbFile, parseTime} from '@/utils/common'
import '@/utils/ai-review.js'

window.aiReviewConfig = {
    apiService: {},
    client: {}
}

export default {
    name: 'invigilateDetail',
    components: {
        pagination, remarkDialog, detailDialog, reviewer
    },
    data() {
        return {
            // height: 250,
            loading: true,
            info: {},
            form: {
                examId: '',
                examineeName: '',
                admissionNo: '',
                ifRemark: '',
                faceCheckStatus: '',
                authenticationType: 'examinee',//examinee是考生，reviewer是工作人员
                pageNumber: 1,
                pageSize: 20
            },
            total: 0,
            questionTypeList: [],
            tableData: [],
            remarkDialogVisible: false,
            detailDialogVisible: false,
            activeName: '0',
            row: null,
            ifRemarkOptions: [
                {dict_value: true, dict_label: '是'},
                {dict_value: false, dict_label: '否'}
            ],
            faceCheckStatusOptions: [
                {dict_value: 'UNCHECKED', dict_label: '未验证'},
                {dict_value: 'PASS', dict_label: '通过'},
                {dict_value: 'NOT_PASS', dict_label: '未通过'}
            ],
            examinerLoading: false,
            examinerImgLoading: false,
        }
    },
    computed: {
        detailTextConfig() {
            return this.$store.state.global.textConfig.backend.invigilateDetail
        },
        searchTextConfig() {
            return this.detailTextConfig.search
        },
        tableTextConfig() {
            return this.detailTextConfig.table
        },
        tableButtonTextConfig() {
            return this.tableTextConfig.button
        },
    },
    watch: {
        tableData() {
            if (this.tableData.length == 0) {
                this.height = 120
            } else {
                this.updateHeight()
            }
        }
    },
    inject: ['reload'],
    beforeRouteEnter(to, from, next) {
        if (from.name === 'invigilate') {
            next(vm => {
                vm.reload()
            })
        } else if (from.name === 'lookPaper') {
            to.meta.isBack = true
            next()
        } else {
            to.meta.isBack = false
            next()
        }
    },
    beforeCreate() {
        getConfig().then(res => {
            window.aiReviewConfig = res.data
        })
    },
    created() {
        this.initDictData()
        this.info = JSON.parse(localStorage.getItem('setInvigilate'))
        this.search(1)
    },
    mounted() {
        const that = this;
        setTimeout(() => {
            that.updateHeight()
        }, 200);
        window.onresize = () => {
            that.updateHeight()
        };
    },
    activated() {
        if (!this.$route.meta.isBack) {
            this.reset()
        } else {
            this.$route.meta.isBack = false
            // this.getBorrowList() /*列表重新加载*/
        }
        this.$route.meta.keepAlive = true
    },
    methods: {
        initDictData() {
            getDict('question_type').then(res => {
                this.questionTypeList = res.data
            });
        },
        getTagValue(val, options) {
            let already = options.find(item => item.dict_value == val)
            return already ? already.dict_label : ''
        },
        search(val) {
            this.loading = true
            if (val) {
                this.form.pageNumber = val
            }
            this.form.examId = this.info.exam.id
            getDetailList(this.form).then(res => {
                if (res.status === 200) {
                    this.tableData = res.data.list
                    this.tableData.forEach(item => {
                        if (item.manualCheck === true && item.faceCheckStatus === '验证通过') {
                            item.faceCheckStatus = '验证通过 (人工校验)'
                        }
                    })
                    this.total = res.data.total
                }
                this.loading = false
                this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
            }).catch(err => {
                this.loading = false
            })
        },
        detail(row) {
            this.row = row
            if (row) {
                let params = {
                    examineeName: row.examinee.examineeName
                }
            }
            this.detailDialogVisible = true
        },
        reset() {
            this.form = this.$options.data().form
            this.form.examineeName = ''
            this.form.admissionNo = ''
            this.form.authenticationType = 'examinee'
            this.form.ifRemark = null
            this.form.faceCheckStatus = null
            this.form.pageSize = 20
            this.search(1)
        },
        download() {
            let url = `${this.config_env.BASE_URL}/api/exam/invigilate/record/detail/download`
            let downloadName = `${this.info.exam.examPlan.name}-考生-${parseTime(Date.now())}.xlsx`
            this.examinerLoading = true
            downloadBolbFile(url, 'get', downloadName, this.form, (loaded, total, percent, status) => {
                if (loaded) {
                    this.examinerLoading = true
                }
                if (percent === 100) {
                    this.examinerLoading = false
                }
                if (status === "error") {
                    this.examinerLoading = false
                }
            })
        },
        downloadImg() {
            let url = `${this.config_env.BASE_URL}/api/exam/invigilate/record/detail/downloadImg`
            let downloadName = `${this.info.exam.examPlan.name}-考生现场拍摄照片-${parseTime(Date.now())}.zip`
            this.examinerImgLoading = true
            downloadBolbFile(url, 'get', downloadName, this.form, (loaded, total, percent, status) => {
                if (loaded) {
                    this.examinerImgLoading = true
                }
                if (percent === 100) {
                    this.examinerImgLoading = false
                }
                if (status === "error") {
                    this.examinerImgLoading = false
                }
            })
        },
        close(data, refresh) {
            this.remarkDialogVisible = data
            this.detailDialogVisible = data
            this.row = null

            if (refresh) {
                this.search()
            }
        },
        updateHeight() {
            if (this.$refs.boardRef) {
                const boardEl = this.$refs.boardRef
                const formEl = boardEl.querySelector('.el-form')
                if (formEl) {
                    this.height = boardEl.clientHeight - formEl.clientHeight - 184
                    this.height = this.height < 460 ? 460 : this.height
                }
            }
        },
        submitTypeFormatter(row) {
            if (row.submitType === 'auto') {
                return '系统自动提交'
            } else if (row.submitType === 'manual') {
                return '主动交卷'
            }
            return ''
        },
    }
}
</script>

<style scoped>
.info {
    color: #555;
    font-size: 15px;
    margin-bottom: 12px;
}

.info span {
    color: #C0C4CC;
    margin-left: 12px;
}

.info span:first-child {
    margin-left: 0;
}

.info i {
    color: #555;
}

.multiRow {
    font-size: 12px;
    /*color: #bbb;*/
    line-height: 12px;
}

.lockedClass {
    background-color: #FF9502;
    /*background-color: #FF455B;*/
    display: inline-block;
    padding: 0 2px;
    text-align: center;
    vertical-align: middle;
    font-style: normal;
    color: #fff;
    overflow: hidden;
    line-height: 16px;
    height: 16px;
    font-size: 10px;
    border-radius: 4px;
    font-weight: 200;
}
</style>
